import React, { useState, useEffect, useCallback } from 'react';
import Form from '.';
import { IProps as ModalProps } from '../../sideModal';

import useAxiosFunction from '../../../../hooks/useAxiosFunction';

import { IBBDD, IBaseBBDD } from '../../../../types/bbdd';

export interface IProps extends ModalProps {
    id: string;
}

const EditForm: React.FC<ModalProps> = ({ onSubmit, id, ...rest }) => {
    const [structure, setStructure] = useState<IBBDD>();

    const {
        response, loading, error, axiosFetch
    } = useAxiosFunction();

    const {
        axiosFetch: postAxiosFetch
    } = useAxiosFunction();

    const onSubmitNewAction = useCallback(async (editedStructure: IBBDD | IBaseBBDD) => {
        try {
            await postAxiosFetch({
                url: `/api/structures/${id}`,
                method: 'put',
                data: { ...editedStructure }
            });
            onSubmit?.();
        } catch (err) {
            if (err instanceof Error) {
                console.warn(err.message);
            }
        }
    }, [id, postAxiosFetch]);

    useEffect(() => {
        axiosFetch({ url: `/api/structures/${id}`, method: 'get' });
    }, []);

    useEffect(() => {
        setStructure(response);
    }, [response]);

    return (
        <>
            {!loading && !error && structure && (
                <Form
                    onSubmit={onSubmitNewAction}
                    structure={structure}
                    {...rest}
                />
            )}
        </>
    );
};

export default EditForm;
